/* ============================================================
   EroticShop — Header Init  v1.0
   Dosya  : assets/header-init.js
   
   Konsolidasyon:
   - Dark Mode Toggle       (eski header.liquid line 1056-1086)
   - Drawer Scroll Lock     (eski header.liquid line 1088-1124)
   - Custom Cart Icon Swap  (eski header.liquid line 1126-1165)
   
   Yükleme : header.liquid en üstünde defer ile
   ============================================================ */

(() => {
  'use strict';

  /* ──────────────────────────────────────────────────────────
     Modül 1: Dark Mode Toggle
     Toggle button yoksa erken çıkar (enable_dark_mode=false durumu)
     ────────────────────────────────────────────────────────── */
  const initDarkMode = () => {
    const STORAGE_KEY = 'theme-preference';
    const btn = document.getElementById('dm-toggle');
    if (!btn) return;

    const getTheme = () => document.documentElement.getAttribute('data-theme') || 'light';

    // Gerçek DOM mutation — View Transition callback'i içinde senkron çalışır
    const applyTheme = (theme) => {
      document.documentElement.setAttribute('data-theme', theme);
      try { localStorage.setItem(STORAGE_KEY, theme); } catch (_) {}
      btn.setAttribute('aria-label', theme === 'dark' ? 'Açık moda geç' : 'Koyu moda geç');
      window.dispatchEvent(new CustomEvent('theme-changed', { detail: { theme } }));
    };

    // View Transitions API → tek GPU cross-fade; desteklenmiyorsa/reduced-motion'da anlık
    const setTheme = (theme) => {
      const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reduce && document.startViewTransition) {
        document.startViewTransition(() => applyTheme(theme));
      } else {
        applyTheme(theme);
      }
    };

    btn.addEventListener('click', () => {
      setTheme(getTheme() === 'dark' ? 'light' : 'dark');
    });

    // İlk yüklemede aria-label set
    const current = getTheme();
    btn.setAttribute('aria-label', current === 'dark' ? 'Açık moda geç' : 'Koyu moda geç');
  };

  /* ──────────────────────────────────────────────────────────
     Modül 2: Drawer Scroll Lock Watcher
     Header drawer kapatıldığında body scroll-lock class'larını temizler
     ────────────────────────────────────────────────────────── */
  const initDrawerWatcher = () => {
    const drawer = document.querySelector('header-drawer details');
    if (!drawer) return;

    const clearScrollLock = () => {
      document.body.classList.remove(
        'overflow-hidden',
        'overflow-hidden-mobile',
        'overflow-hidden-tablet',
        'overflow-hidden-desktop'
      );
      document.documentElement.style.overflow = '';
      document.documentElement.style.position = '';
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'open' && !drawer.hasAttribute('open')) {
          setTimeout(clearScrollLock, 200);
        }
      });
    });

    observer.observe(drawer, { attributes: true });
  };

  /* ──────────────────────────────────────────────────────────
     Modül 3: Custom Cart Icon Swap
     Dawn'ın default cart SVG'sini özel SVG ile değiştirir
     Cart count badge güncellenince re-apply eder
     ────────────────────────────────────────────────────────── */
  const initCustomCartIcon = () => {
    const cartEl = document.getElementById('cart-icon-bubble');
    if (!cartEl) return;

    const CART_SVG = `<span class="svg-wrapper custom-cart-icon">
      <svg viewBox="0 0 24 24" aria-hidden="true" width="22" height="22" fill="none" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="9" cy="21" r="1"/>
        <circle cx="20" cy="21" r="1"/>
        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
      </svg>
    </span>`;

    const applyTheme = () => {
      const svg = cartEl.querySelector('.custom-cart-icon svg');
      if (!svg) return;
      const isDark = document.documentElement.getAttribute('data-theme') === 'dark';
      svg.setAttribute('stroke', isDark ? '#e8e8e8' : '#333');
    };

    const ensureCustomIcon = () => {
      // Özel ikon yoksa ekle
      if (!cartEl.querySelector('.custom-cart-icon')) {
        cartEl.insertAdjacentHTML('afterbegin', CART_SVG);
      }
      // Dawn'ın default ikonlarını gizle
      const dawnIcons = cartEl.querySelectorAll('.icon-cart, .svg-wrapper:not(.custom-cart-icon)');
      dawnIcons.forEach((el) => {
        if (!el.classList.contains('custom-cart-icon')) {
          el.style.display = 'none';
        }
      });
      applyTheme();
    };

    ensureCustomIcon();

    // Cart count değiştiğinde Dawn DOM'u yeniler → re-apply
    const observer = new MutationObserver(ensureCustomIcon);
    observer.observe(cartEl, { childList: true, subtree: true });

    // Theme değiştiğinde stroke rengini güncelle
    window.addEventListener('theme-changed', applyTheme);
  };

  /* ──────────────────────────────────────────────────────────
     Bootstrap
     DOM hazır olunca tüm modülleri başlat
     ────────────────────────────────────────────────────────── */
  const bootstrap = () => {
    initDarkMode();
    initDrawerWatcher();
    initCustomCartIcon();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();